import { CSSProperties } from 'react'

const commonRow = {
  display: 'flex',
  marginBottom: 16,
  flexWrap: 'wrap',
}

const commonCosts = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
} as CSSProperties

const commonValue = {
  marginLeft: 'auto',
} as CSSProperties

export const s = {
  closeIcon: {
    fontSize: 50,
    color: 'white',
    marginTop: 28,
    right: 28,
  },
  modalStyle: {
    padding: 0,
    marginTop: 60,
  },
  image: {
    width: '100%',
    height: 428,
    objectFit: 'cover',
  } as CSSProperties,
  header: {
    display: 'flex',
    alignItems: 'flex-end',
    marginLeft: 128,
    marginTop: 60,
    marginBottom: 30,
  } as CSSProperties,
  spaceHeader: {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 4,
      marginBottom: 28,
    } as CSSProperties,
    about: {
      marginTop: 4,
      marginBottom: 4,
    } as CSSProperties,
    tour: {
      display: 'flex',
      alignItems: 'center',
    } as CSSProperties,
    tourLink: {
      fontSize: 16,
      marginLeft: 4,
      lineHeight: 1.5,
    } as CSSProperties,
  },
  venueTitle: {
    marginLeft: 0,
    marginTop: 0,
    marginRight: 20,
    marginBottom: 0,
  },
  spaceTitle: {
    margin: 0,
    marginBottom: 2,
  },
  main: {
    paddingBottom: 65,
    display: 'flex',
  } as CSSProperties,
  content: {
    width: 500,
    marginLeft: 128,
    marginRight: 15,
  },
  contentTitle: {
    marginBottom: 28,
  },
  contentRow: {
    ...commonRow,
    gap: 4,
  } as CSSProperties,
  featuresRow: {
    ...commonRow,
    gap: 12,
  } as CSSProperties,
  contentColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 28,
  } as CSSProperties,
  columnTitle: {
    marginBottom: 5,
  },
  downloadIcon: {
    marginRight: 6.5,
  } as CSSProperties,
  spatialConfigurationLabels: {
    paddingRight: 12,
  } as CSSProperties,
  sidebar: {
    root: {
      width: 300,
      marginRight: 128,
      display: 'flex',
      flexDirection: 'column',
    } as CSSProperties,
    title: {
      marginBottom: 28,
    } as CSSProperties,
    costDescription: {
      marginBottom: 16,
    },
    divider: {
      marginTop: 8,
      marginBottom: 16,
      backgroundColor: '#D9D9D9',
    } as CSSProperties,
    optionalExtras: {
      title: {
        fontSize: 16,
        marginTop: 'unset',
        marginBottom: 16,
      },
      value: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        ...commonValue,
      } as CSSProperties,
    },
    costs: {
      marginBottom: 8,
      ...commonCosts,
    } as CSSProperties,
    totalCost: {
      marginBottom: 20,
      ...commonCosts,
    } as CSSProperties,
    value: {
      ...commonValue,
    },
    buttons: {
      height: 48,
      marginBottom: 20,
    },
  },
}
